import { Injectable } from '@angular/core'
import { FacetValue } from '@spartacus/core'
import { BehaviorSubject } from 'rxjs'
import { MbConstants } from '../../shared/mb-constants'

@Injectable({
  providedIn: 'root'
})
export class HomepageSearchService {

  searchTerm = ''
  facets = ''
  facetsList: FacetValue[] = []
  hash: string = ''
  homepageSearchQuery: string = ''
  homepageSearchQuery$ = new BehaviorSubject<string>(this.homepageSearchQuery)
  constants = MbConstants

  addSearchTermToQuery (term: string) {
    this.searchTerm = term
    this.updateSearchHashToQuery()
    this.updateHomepageSearchQuery()
  }

  removeSearchTermFromQuery () {
    this.searchTerm = ''
    this.updateHomepageSearchQuery()
  }

  addFacetToQuery (facet: FacetValue) {
    this.facetsList.push(facet)
    this.updateFacetsString()
    this.updateSearchHashToQuery()
    this.updateHomepageSearchQuery()
  }

  removeFacetFromQuery (facet: FacetValue) {
    this.facetsList.splice(this.facetsList.findIndex(item =>
      item?.categoryName === facet?.categoryName && item?.facetValue === facet?.facetValue), 1)
    this.updateFacetsString()
    this.updateSearchHashToQuery()
    this.updateHomepageSearchQuery()
  }

  clearSearchQueries () {
    this.searchTerm = ''
    this.facets = ''
    this.hash = ''
    this.facetsList = []
    this.updateHomepageSearchQuery()
  }

  private updateHomepageSearchQuery () {
    this.homepageSearchQuery = ''
    if (this.facets?.length) {
      this.homepageSearchQuery += this.searchTerm + this.constants.COLON_RELEVANCE + this.facets
      this.homepageSearchQuery += this.constants.HASH_SYMBOL + this.hash
    }
    this.homepageSearchQuery$.next(this.homepageSearchQuery)
  }

  private updateFacetsString () {
    this.facets = ''
    this.facetsList.forEach(item => this.facets += item?.facetValue)
  }

  private updateSearchHashToQuery (): void {
    this.hash = ''
    this.facetsList.forEach(item => {
      const decodedHash = atob(item?.facetValueHash || '')
      const uglyFacetValue = decodedHash?.split(this.constants.RELEVANCE)?.pop() || ''
      this.hash += uglyFacetValue
    })
    this.hash = btoa(this.searchTerm + this.constants.COLON_RELEVANCE + this.hash)
  }
}
